var _Logger_logger;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
const noop = () => { };
class Logger {
    constructor() {
        _Logger_logger.set(this, this.createLogger({}));
    }
    get log() {
        return __classPrivateFieldGet(this, _Logger_logger, "f").log;
    }
    get info() {
        return __classPrivateFieldGet(this, _Logger_logger, "f").info;
    }
    get error() {
        return __classPrivateFieldGet(this, _Logger_logger, "f").error;
    }
    get warn() {
        return __classPrivateFieldGet(this, _Logger_logger, "f").warn;
    }
    get metrics() {
        return __classPrivateFieldGet(this, _Logger_logger, "f").metrics;
    }
    get action() {
        return __classPrivateFieldGet(this, _Logger_logger, "f").action;
    }
    setLogger(settings = {}) {
        __classPrivateFieldSet(this, _Logger_logger, this.createLogger(settings), "f");
    }
    /**
     * @inner
     *
     * To override the default logger, use setLogger
     */
    createLogger(settings) {
        var _a, _b, _c, _d, _e, _f;
        return {
            log: (_a = settings.log) !== null && _a !== void 0 ? _a : noop,
            info: (_b = settings.info) !== null && _b !== void 0 ? _b : noop,
            warn: (_c = settings.warn) !== null && _c !== void 0 ? _c : noop,
            error: (_d = settings.error) !== null && _d !== void 0 ? _d : noop,
            metrics: (_e = settings.metrics) !== null && _e !== void 0 ? _e : noop,
            action: (_f = settings.action) !== null && _f !== void 0 ? _f : noop,
        };
    }
}
_Logger_logger = new WeakMap();
export const logger = new Logger();
